import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVulkanComponent } from './simple-icons-vulkan.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVulkanComponent ],
    exports:      [ SimpleIconsVulkanComponent ],
    bootstrap:    []
})
export class SimpleIconsVulkanModule {}
